import { mergeAttributes, Node } from '@tiptap/core';
import { VueNodeViewRenderer } from '@tiptap/vue-3';
import CopilotMentionNodeView from './CopilotMentionNodeView.vue';

export const CopilotMention = Node.create({
  name: 'copilotMention',

  addOptions() {
    return {
      onOpen: null,
    };
  },

  group: 'inline',

  inline: true,

  selectable: true,

  atom: true,

  addAttributes() {
    return {
      type: {
        default: null,
        parseHTML: element => element.getAttribute('data-mention-type'),
        renderHTML: attributes => {
          if (!attributes.type) return {};
          return { 'data-mention-type': attributes.type };
        },
      },
      id: {
        default: null,
        parseHTML: element => element.getAttribute('data-id'),
        renderHTML: attributes => {
          if (attributes.id == null) return {};
          return { 'data-id': String(attributes.id) };
        },
      },
      name: {
        default: '',
        parseHTML: element => element.getAttribute('data-name'),
        renderHTML: attributes => {
          if (!attributes.name) return {};
          return { 'data-name': attributes.name };
        },
      },
      subtitle: {
        default: '',
        parseHTML: element => element.getAttribute('data-subtitle') || '',
        renderHTML: attributes => {
          if (!attributes.subtitle) return {};
          return { 'data-subtitle': attributes.subtitle };
        },
      },
      portalSlug: {
        default: '',
        parseHTML: element => element.getAttribute('data-portal-slug') || '',
        renderHTML: attributes => {
          if (!attributes.portalSlug) return {};
          return { 'data-portal-slug': attributes.portalSlug };
        },
      },
    };
  },

  parseHTML() {
    return [{ tag: `span[data-type="${this.name}"]` }];
  },

  renderHTML({ HTMLAttributes }) {
    return [
      'span',
      mergeAttributes(
        { 'data-type': this.name, class: 'copilot-mention-chip' },
        HTMLAttributes
      ),
    ];
  },

  renderText() {
    return '';
  },

  addNodeView() {
    return VueNodeViewRenderer(CopilotMentionNodeView);
  },
});

export default CopilotMention;
